import React from 'react';

import { styled } from '@mui/system';
import { appInsights } from '../../../auth/appInsight';
import { getStringProduct } from '../../../utils/utilityFunctions';

const Divider = styled('div')((props) => {
  const {theme} = props
  return ({
  marginTop: props.marginTop || '20px ',
  marginBottom: props.marginBottom || '20px',
  height: '0.5px',
  backgroundColor: props.dividerbackgroundcolor,
  [theme.breakpoints.up('xll')]: {
    height: getStringProduct(1.25, '0.5px'),
    marginTop: getStringProduct(1.25, props?.marginTop || '20px') ,
    marginBottom: getStringProduct(1.25, props?.marginBottom || '20px'),
  },
  [theme.breakpoints.up('xlll')]: {
    height: getStringProduct(1.66, '0.5px'),
    marginTop: getStringProduct(1.66, props?.marginTop || '20px') ,
    marginBottom: getStringProduct(1.66, props?.marginBottom || '20px'),
  },
  [theme.breakpoints.up('xl4')]: {
    height: getStringProduct(2.46, '0.5px'),
    marginTop: getStringProduct(2.46, props?.marginTop || '20px') ,
    marginBottom: getStringProduct(2.46, props?.marginBottom || '20px'),
  },
})});
const FreedomColorDivider = (props) => {
  const { dividerbackgroundcolor } = props;
  // const classes = useStyle();
  try {
    return <Divider {...props} dividerbackgroundcolor={dividerbackgroundcolor} />;
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomColorDivider;
